module.exports = __webpack_public_path__ + "static/media/click-piece.f72667b1.mp3";